import { render, staticRenderFns } from "./term.vue?vue&type=template&id=0f49da8f&scoped=true&"
import script from "./term.vue?vue&type=script&lang=js&"
export * from "./term.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f49da8f",
  null
  
)

export default component.exports